import React from "react";
import withApp from "../../hocs/withApp";
import withAuth from "../../hocs/withAuth";
import MainLayout from "../../components/common/layout/main/MainLayout";
import { Box, Grid2 } from "@mui/material";
import DoanhThuNhaHangTuanNay from "./components/DoanhThuNhaHangTuanNay";
import DoanhThuSieuThiTuanNay from "./components/DoanhThuSieuThiTuanNay";

function DashboardPage() {
  return (
    <MainLayout>
      <Box>
        <Grid2 container spacing={2}>
          <Grid2 size={{ xs: 12, md: 6 }}>
            <DoanhThuNhaHangTuanNay />
          </Grid2>
          <Grid2 size={{ xs: 12, md: 6 }}>
            <DoanhThuSieuThiTuanNay />
          </Grid2>
          <Grid2 size={{ xs: 12 }}></Grid2>
        </Grid2>
      </Box>
    </MainLayout>
  );
}

export default withAuth(withApp(DashboardPage));
